import { marketingParamsAvailable } from 'src/modules/tracking/analytics/helpers';
import type { Analytics } from 'src/modules/tracking/analytics/types';
import sleep from 'src/utils/sleep';

export const recordAnalytics = async (
  params: qs.ParsedQs,
  analytics: Analytics,
) => {
  if (marketingParamsAvailable(params)) {
    analytics.trackPageView({
      eventName: 'login_redirect_displayed',
      currentPage: 'login redirect',
    });
    await sleep();
  }
};
